module.exports = __webpack_public_path__ + "static/img/qcsh5.6b2a2af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qcsh5.jpg
// module id = QiJ1
// module chunks = 0